/**
 * Created: 2026-09-XX
 * Initial commit: Add placeholder coach home page
 *
 * Placeholder landing page for the coach role. Coach-specific features
 * (schedule, course roster, etc.) will be built out here later.
 */

import { Box, Typography } from '@mui/material'
import { useRole } from '../hooks'

export default function CoachHomePage() {
  const role = useRole()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h4">教练首页</Typography>
      <Typography color="text.secondary">
        {role.currentSite?.name ?? '场馆'} · 教练
      </Typography>
    </Box>
  )
}
